import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterNCC({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ncc: "",
    dien_thoai: "",
    email: "",
    ma_so_thue: "",
    nhom_ncc: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = { $or: [] };
    if (filter.ncc) {
      condition.$or.push({
        ma_kh: {
          $regex: filter.ncc?.split(" ")?.join(".*"),
          $options: "i",
        },
      });
      condition.$or.push({
        ten_kh: {
          $regex: filter.ncc?.split(" ")?.join(".*"),
          $options: "i",
        },
      });
    }
    if (filter.dien_thoai) {
      condition.dien_thoai = { $regex: filter.dien_thoai, $options: "i" };
    }
    if (filter.email) {
      condition.email = { $regex: filter.email, $options: "i" };
    }
    if (filter.ma_so_thue) {
      condition.ma_so_thue = { $regex: filter.ma_so_thue, $options: "i" };
    }
    if (filter.nhom_ncc) {
      condition.nh_kh = filter.nhom_ncc._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Mã, tên nhà cung cấp"
        placeholder="Tìm theo mã, tên nhà cung cấp"
        value={filter.ncc}
        onSearch={(val) => setFilter({ ...filter, ncc: val })}
      />
      <FilterText
        direction="column"
        label="Email"
        placeholder="Tìm theo email khách hàng"
        value={filter.email}
        onSearch={(val) => setFilter({ ...filter, email: val })}
      />
      <FilterText
        direction="column"
        label="Điện thoại"
        placeholder="Tìm theo điện thoại khách hàng"
        value={filter.dien_thoai}
        onSearch={(val) => setFilter({ ...filter, dien_thoai: val })}
      />
      <FilterText
        direction="column"
        label="Mã số thuế"
        placeholder="Tìm theo mã số thuế"
        value={filter.ma_so_thue}
        onSearch={(val) => setFilter({ ...filter, ma_so_thue: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Nhóm nhà cung cấp"
        placeholder="Chọn nhóm nhà cung cấp"
        selectTitle="Chọn nhóm nhà cung cấp"
        placeholderSearch="Tìm theo tên nhóm nhà cung cấp"
        apiCode="dmnhkh"
        searchFields={["group_name"]}
        getOptionLabel={(option) => option.group_name}
        checkEqual={(value, option) => value?._id === option?._id}
        value={filter.nhom_ncc}
        onChange={(val) => setFilter({ ...filter, nhom_ncc: val })}
      />
    </WrapperFilter>
  );
}

export default FilterNCC;
